import React from 'react';

interface CheckboxInputProps {
  label: string;
  value: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  width?: string;
  custom_test_id?: string;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  width = 'w-1/4',
  custom_test_id,
  ...rest
}) => {
  return (
    <label
      key={'checkbox-input-div_' + label}
      className={'form-control ' + width}
    >
      <span className="label-text">{label}</span>
      <input
        key={'checkbox-input_' + label}
        className="checkbox checkbox-primary"
        data-testid={custom_test_id}
        type="checkbox"
        checked={value}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
    </label>
  );
};
